import { render, staticRenderFns } from "./CRUDTiposEquipamentos.vue?vue&type=template&id=78af073b&"
import script from "./CRUDTiposEquipamentos.vue?vue&type=script&lang=js&"
export * from "./CRUDTiposEquipamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports